<!--业务配置设置-->
<template>
  <div class="main" :style="{height: tableHeight + 'px'}">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden"></el-input>
      <el-form-item label="拆解厂名称" prop="factory">
        <el-input v-model="form.factory" maxlength="50" show-word-limit class="width4"></el-input>
      </el-form-item>
      <el-form-item label="拆解厂地址" prop="address">
          <el-input v-model="form.address" maxlength="80" show-word-limit class="width5"></el-input>
      </el-form-item>
      <el-form-item label="开放场地数">
        <el-input-number v-model="form.openSite" :min="0" />
        &nbsp;
        <el-tooltip effect="customized">
          <template #content>拆解厂默认每天能开放的场地数量即进厂车辆数。</template>
          <el-icon :size="16"><InfoFilled /></el-icon>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="提前开放预约">
        <el-input-number v-model="form.reserveDay" :min="0" />（天）
        <el-tooltip effect="customized">
          <template #content>拆解厂预约，提前开放最近预约几天的天数；0为关闭，1为明天...</template>
          <el-icon :size="16"><InfoFilled /></el-icon>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="不开放日期">
        <el-date-picker v-model="closeDate" type="dates" value-format="YYYY-MM-DD" :disabled-date="disabledDate" placeholder="选择多个日期" clearable=false class="width4" />
        &nbsp;
        <el-tooltip effect="customized">
          <template #content>拆解厂预约，不开放日期不会生成场地预约信息。</template>
          <el-icon :size="16"><InfoFilled /></el-icon>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="确认时长">
        <el-input-number v-model="form.confirmDuration" :min="0" /> （分钟）
        &nbsp;
        <el-tooltip effect="customized">
          <template #content>预约抢位确认前最多保留时长，保留时间内其它货场不能预约该位。</template>
          <el-icon :size="16"><InfoFilled /></el-icon>
        </el-tooltip>
      </el-form-item>
      <div class="main-footer">
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'businessConfig',
  data () {
    return {
      tableHeight: 0,
      closeDate: [],
      form: {
        id: '',
        factory: '',
        address: '',
        openSite: 5,
        reserveDay: 7,
        closeDate: '',
        confirmDuration: 30
      },
      rules: {
        factory: [
          { required: true, message: '请输入拆解厂名称', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    // console.log('configQX=', this.$route.params.qx)
    this.getTableHeight()
    this.editInfo()
  },
  methods: {
    disabledDate (time) {
      return time.getTime() < Date.now()
    },
    async editInfo () {
      const { data: ret } = await this.$http.get1(this.$api.businessconfig)
      if (ret.status === 0 && ret.data !== null) {
        this.siteFolderDisabled = true
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        // 字符串转数组
        this.closeDate = this.form.closeDate.split(',')
      } else {
        this.$message.error(ret.message)
      }
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          // 数组转字符串
          this.form.closeDate = this.closeDate.toString()
          // console.log('this.form=', this.form)
          const { data: ret } = await this.$http.post(this.$api.businessconfigsave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 50
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.main{
  width: 100%;
  /* 设置出现滚动条 */
  overflow: auto;
  // border: solid 1px #666;
  .el-form {
    padding: 10px 60px 30px 0;
  }
  .main-footer{
    text-align: right;
  }
}
</style>
